/* prettier-ignore */

import { inject, Injectable } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { NewCustomRouteService } from 'src/app/pages/new-custom-route/new-custom-route.service';
import { of } from 'rxjs';
import { isNotSuccess, validateRoute } from './guards/custom-route.guard';

type Result = { is_successful: true, content?: string, reason?: string } | { is_successful: false; reason: string };

@Injectable({ providedIn: 'root' })

export class ShowItemDetailsService {
  private _modalController = inject(ModalController);
  private _customRouteService = inject(NewCustomRouteService);
  
  show(args: any) {
    this._modalController?.dismiss().catch(e => {
        console.warn("No modal found on dismiss")
    });

    const route = this._customRouteService.route();
    const ctx = validateRoute(route, 1);
    if (isNotSuccess(ctx)){
        return of<Result>(ctx);
    }

    if (!args.element_id) {
        return of<Result>({ 
            is_successful: false, 
            reason: 'element_id es obligatorio' 
        })
    }

    if (!args.type) {
        return of<Result>({ 
            is_successful: false, 
            reason: 'type es obligatorio' 
        })
    }

    const foundItem = this._customRouteService.allItems?.find(item => Number(item.id) == Number(args?.element_id) && item.type == args?.type);
    if (!foundItem){
        return of<Result>({ 
            is_successful: false, 
            reason: 'No se ha encontrado el recurso para mostrar detalles' 
        })
    }

    this._customRouteService.modalItemInfo(foundItem);
    return of<Result>({ is_successful: true });
  }

}